/**
 * Bubbel-Specialist Custom Brand JavaScript
 *
 * Sold-out products: move to end of every product grid
 */
(function() {
  function sortSoldOutToEnd() {
    var grids = document.querySelectorAll('.o-layout');
    grids.forEach(function(grid) {
      var cards = grid.querySelectorAll(':scope > .o-layout__item');
      if (cards.length < 2) return;

      var hasSoldOut = false;
      cards.forEach(function(card) {
        if (card.querySelector('.product-card--sold-out')) {
          hasSoldOut = true;
        }
      });
      if (!hasSoldOut) return;

      /* Collect available and sold-out items */
      var available = [];
      var soldOut = [];
      cards.forEach(function(card) {
        if (card.querySelector('.product-card--sold-out')) {
          soldOut.push(card);
        } else {
          available.push(card);
        }
      });

      /* Re-append in order: available first, sold-out last */
      available.forEach(function(card) { grid.appendChild(card); });
      soldOut.forEach(function(card) { grid.appendChild(card); });
    });
  }

  /* Run on DOMContentLoaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortSoldOutToEnd);
  } else {
    sortSoldOutToEnd();
  }

  /* Also observe for dynamically loaded content (AJAX pagination, filters) */
  var observer = new MutationObserver(function(mutations) {
    var shouldSort = false;
    mutations.forEach(function(m) {
      if (m.addedNodes.length > 0) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList.contains('o-layout__item') || node.querySelector && node.querySelector('.product-card--sold-out'))) {
            shouldSort = true;
          }
        });
      }
    });
    if (shouldSort) {
      requestAnimationFrame(sortSoldOutToEnd);
    }
  });

  var mainContent = document.getElementById('MainContent') || document.body;
  observer.observe(mainContent, { childList: true, subtree: true });
})();
